// extracted by mini-css-extract-plugin
export default {"page":"page__iNfsAfxj","headerButtons":"headerButtons___SjTK6G6"};